import { DEFAULT_SETTINGS } from '../config';
import type { SaveData } from '../types';

const KEY = 'typing-cannon-save';
export const defaultSave = (): SaveData => ({ version: 1, settings: { ...DEFAULT_SETTINGS }, level: 1, xp: 0, totalWords: 0, bestScore: {}, mastery: {}, completedLevels: {}, firstRunDone: false });

export function migrateSave(raw: unknown): SaveData {
  if (!raw || typeof raw !== 'object') return defaultSave();
  const value = raw as Partial<SaveData>;
  return {
    ...defaultSave(),
    version: 1,
    settings: { ...DEFAULT_SETTINGS, ...(value.settings ?? {}) },
    level: typeof value.level === 'number' && value.level > 0 ? value.level : 1,
    xp: typeof value.xp === 'number' ? value.xp : 0,
    totalWords: typeof value.totalWords === 'number' ? value.totalWords : 0,
    bestScore: value.bestScore && typeof value.bestScore === 'object' ? value.bestScore : {},
    mastery: value.mastery && typeof value.mastery === 'object' ? value.mastery : {},
    completedLevels: value.completedLevels && typeof value.completedLevels === 'object' ? value.completedLevels : {},
    firstRunDone: Boolean(value.firstRunDone),
  };
}

export function loadSave(): SaveData {
  try { return migrateSave(JSON.parse(localStorage.getItem(KEY) ?? 'null')); } catch { return defaultSave(); }
}

export function storeSave(save: SaveData): void { localStorage.setItem(KEY, JSON.stringify(save)); }
export function resetSave(): SaveData { const fresh = defaultSave(); storeSave(fresh); return fresh; }
